import type { FaireProductEntity } from "../../entity_types/product";

export const p_26uar648p7: FaireProductEntity = {
  token: "p_26uar648p7",
  type: "product",
  name: "Dubai Chocolate",
  brandToken: "b_xtvv45q74f",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/36cb3b3b0b2591b851375479763c2b6421a80beacd40fbd6d9a348504e458cc8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6006e32cc852c9cf3839aff052261f0b2d2818fc28373fdfb013cb2ba3f475a9.jpeg",
  ],
  priceDollars: 4.16,
  description:
    "Dubai Chocolate Fudge (Handcrafted Gourmet Fudge)\n\nLooking for a rich, unforgettable chocolate experience? Our Dubai Chocolate Fudge is a luxurious twist on classic handmade fudge — crafted in small batches for ultra-creamy texture and deep, indulgent flavor.\n\nMade using Meem’s signature old-fashioned fudge recipe, this gourmet chocolate fudge is smooth, velvety, and perfectly balanced. Every bite melts in your mouth with rich cocoa notes and a hint of exotic inspiration, making it a standout treat for chocolate lovers.\n\nWhether you’re shopping for a unique gift, building a gourmet fudge box, or treating yourself, this premium chocolate fudge delivers bakery-quality flavor straight to your door.\n\nWhy You’ll Love It\n\n * Handcrafted small-batch gourmet fudge \n * Rich, creamy, melt-in-your-mouth texture \n * Made with premium chocolate ingredients \n * Unique flavor inspired by Dubai-style luxury desserts \n * Perfect for gifts, holidays, and special occasions \n\n\n\n\nPerfect For:\n\n * Chocolate lovers and fudge collectors \n * Gourmet gift boxes and care packages \n * Holiday desserts and party trays \n * Unique online fudge gifts \n\n\n\nAt Meem’s Fudge Shoppe, we believe fudge should feel nostalgic, comforting, and a little magical. Our Dubai Chocolate Fudge blends old-fashioned craftsmanship with a modern, indulgent twist you won’t find in ordinary fudge.\n\nOrder now and experience handcrafted gourmet fudge delivered fresh to your door.\n\n\n\n\n",
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:29:27.981Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
